import React, { useMemo } from 'react';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { PhantomWalletAdapter, SolflareWalletAdapter } from '@solana/wallet-adapter-wallets';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import '@solana/wallet-adapter-react-ui/styles.css';
import { useNetwork } from './NetworkContext.js';
import { getRpcUrlForNetwork } from '../lib/networkConfig.js';

interface WalletContextProviderProps {
  children: React.ReactNode;
}

export function WalletContextProvider({ children }: WalletContextProviderProps) {
  const { network } = useNetwork();
  const endpoint = useMemo(() => getRpcUrlForNetwork(network), [network]);

  const wallets = useMemo(() => {
    const adapters = [];
    try {
      adapters.push(new PhantomWalletAdapter());
    } catch {
      // optional adapter
    }
    try {
      adapters.push(new SolflareWalletAdapter());
    } catch {
      // optional adapter
    }
    return adapters;
  }, []);

  const Provider = ConnectionProvider as React.ComponentType<{
    endpoint: string;
    children: React.ReactNode;
  }>;

  return (
    <Provider key={network} endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>{children}</WalletModalProvider>
      </WalletProvider>
    </Provider>
  );
}